import { EXPENSE_LIST_FAIL, EXPENSE_LIST_REQUEST, EXPENSE_LIST_SUCCESS } from "../constats/expense.constant";

export const expenseListReducer = (state={}, action) => {
    switch (action.type) {
        case EXPENSE_LIST_REQUEST:
            return {
                loading: true
            };
        case EXPENSE_LIST_FAIL:
            return {
                loading: false,
                error: action.payload
            };
        case EXPENSE_LIST_SUCCESS:
            return {
                loading: false,
                data: action.payload
            };
        default:
            return state;
    }
}